import { render, staticRenderFns } from "./Wish2.vue?vue&type=template&id=6fa2c222&scoped=true"
import script from "./Wish2.vue?vue&type=script&lang=js"
export * from "./Wish2.vue?vue&type=script&lang=js"
import style0 from "./Wish2.vue?vue&type=style&index=0&id=6fa2c222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa2c222",
  null
  
)

export default component.exports